<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ formatInteger(objEdicao.cdatividade) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Nome</label>
                <input type="text" v-model="objEdicao.nmatividade" maxlength="80" v-uppercase />
            </div>
            
            <div class="form-item-char20">
                <label class="label-caption">CNAE</label>
                <input type="text" v-model="objEdicao.cnae" maxlength="7" v-digits-only />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item-char20">
                <label class="label-caption">PLA-Expedição</label>
                <input type="text" v-model="objEdicao.plaexpedicao_subtipo" maxlength="6" v-uppercase />
            </div>
            <div class="form-item-char20">
                <label class="label-caption">PLA-Leite</label>
                <input type="text" v-model="objEdicao.plaleite_subtipo" maxlength="6" v-uppercase />
            </div>
            <div class="form-item-char20">
                <label class="label-caption">PLA-Mel</label>
                <input type="text" v-model="objEdicao.plamel_subtipo" maxlength="6" v-uppercase />
            </div>
            <div class="form-item-char20">
                <label class="label-caption">PLA-M.P.</label>
                <input type="text" v-model="objEdicao.plamp_subtipo" maxlength="6" v-uppercase />
            </div>
            <div class="form-item-char20">
                <label class="label-caption">PLA-Produção</label>
                <input type="text" v-model="objEdicao.plaproducao_subtipo" maxlength="6" v-uppercase />
            </div>
            <div class="form-item">
                <label class="label-caption">Observações</label>
                <input type="text" v-model="objEdicao.obs" maxlength="200" v-uppercase />
            </div>
            
            <div class="form-item-char20">
                <TpProdutoMapaSelect class="form-item" v-model:opcaoSelecionada="objEdicao.tpproduto_mapa" />
            </div>
        </div>

        <div class="row-end">
            <label for="ckAtivo">Ativo</label>
            <input type="checkbox" class="input-checkbox" id="ckAtivo" v-model="ckAtivo" />
        </div>

        <div class="row-end">
            <label for="ckMpLeite">Informar Matéria Prima Leite</label>
            <input type="checkbox" class="input-checkbox" id="ckMpLeite" v-model="ckMpLeite" />
        </div>

        <div class="row-end row-space">
            <label for="ckMpMel">Informar Matéria Prima Mel</label>
            <input type="checkbox" class="input-checkbox" id="ckMpMel" v-model="ckMpMel" />
        </div>

        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="button" class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>
    </div>
</template>
  
<script setup>
import { criarAtividade } from '@/models/atividade';
import { onMounted, ref } from 'vue';
import { formatInteger } from '@/funcoes/utils';
import { genericPut, getCadastroById } from '@/funcoes/api';
import { globalStore } from '@/globals';
import TpProdutoMapaSelect from '@/selects/estaticos/TpProdutoMapaSelect.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const ckAtivo = ref(false);
const ckMpLeite = ref(false);
const ckMpMel = ref(false);
const isLoading = ref(false);
const msgAlerta = ref(null);
const objEdicao = ref(criarAtividade());

const cancelForm = () => {emit('close');}

const lerDados = async() => {
    try{
        isLoading.value = true;
        msgAlerta.value       = null;
        if (props.idEdicao > 0) {
            try{
                const req = await getCadastroById('atividade', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){msgAlerta.value = error}
        }else{
            objEdicao.value.idep        = globalStore.idep;
        }
        objEdicao.value.idlogin         = globalStore.idlogin;
        ckAtivo.value                   = objEdicao.value.ativo === 'S';        
        ckMpLeite.value                 = objEdicao.value.ckmpleite === 'S';        
        ckMpMel.value                   = objEdicao.value.ckmpmel === 'S';        
    } catch (error) {msgAlerta.value = error;
    }finally{isLoading.value=false;}
};

const salvarDados = async() => {
    if (!objEdicao.value.nmatividade || objEdicao.value.nmatividade.trim() === '') {msgAlerta.value='Informe o nome da atividade'; return;}
    try {
        isLoading.value             = true;
        msgAlerta.value                   = null;
        objEdicao.value.ativo       = ckAtivo.value ? 'S' : 'N';
        objEdicao.value.ckmpleite   = ckMpLeite.value ? 'S' : 'N';
        objEdicao.value.ckmpmel     = ckMpMel.value ? 'S' : 'N';
        const response              = await genericPut('/cad/atividade', objEdicao.value);
        if (response.bolok === 1){
            emit('save');
            emit('close');
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally{isLoading.value=false;}
};

onMounted(lerDados);
</script>